import React, { Fragment } from 'react';
import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import whsOrderAwbWeightStyles from './whsOrderAwbWeight.module.css';
import commonStyles from '../../common/common.module.css';
import GhaPickupStatusAwb from '../../../models/GhaPickupStatusAwb';
import { TextField, RadioGroup, FormControlLabel, Radio, Paper } from '@material-ui/core';
import MaterialTable from 'material-table';
import tableIcons from '../../../utils/editTableIcons';
import Dimension from '../../../models/Dimension';

const TEXT_FIELD_PADDINGS: string = '7px 12px';

const isNonNegativeDimension = (item: { length?: any; width?: any; height?: any; pieces?: any; weightPc?: any }): boolean => {
  const fields = [item.length, item.width, item.height, item.pieces, item.weightPc];
  return fields.every((value) => {
    if (value === '' || value === null || value === undefined) {
      return true;
    }
    const n = Number(value);
    return !isNaN(n) && n >= 0;
  });
};

const styles = (theme: Theme) =>
  createStyles({
    button: {
      marginBottom: '20px',
      marginRight: '10px',
      minWidth: '150px'
    },
    width55: {
      width: '55%',
      '@media only screen and ( max-width: 991px )':{
        width: '100%',
      },
    },
    weightRadio: {
      display: 'flex',
      justifyContent: 'space-between',
      flexWrap: 'nowrap'
    },
    weightInput: {
      width: '100%'
    },
    ipcolor:{
      color: 'var(--primaryblue)'
    }
  });

interface WhsOrderAwbWeightProps {
  classes: any;
  awbNumber: string;
  save: Function;
  exit: Function;
  orderAwb: GhaPickupStatusAwb;
  handleChange: Function;
  addRow: Function;
  currentDimension: Dimension;
  setOrderAwb: Function;
  calculatedCWT: number;
  openExceededPiecesConfirmation: Function;
  onlyRead?: boolean;
  weightType: string;
  calculationChange: Function;
};

const whsOrderAwbWeight = (props: WhsOrderAwbWeightProps) => {

  const { classes, awbNumber, orderAwb, currentDimension } = props;


  return (
    <div className={ whsOrderAwbWeightStyles.wrapper }>
      <div className={ whsOrderAwbWeightStyles.header }>
        <span className={ whsOrderAwbWeightStyles.awbNumber }>{ awbNumber }</span>
        <span>Dims & Weight</span>
      </div>
      <div className={ [commonStyles.wrapper, commonStyles.dFlex, whsOrderAwbWeightStyles.pcsWtWrapper].join(" ") }>
        <div className={ `${ whsOrderAwbWeightStyles.width50 } ${ commonStyles.inputLabelWrapper }` }>
          <label className={ commonStyles.inputLabel }> PCS </label>
          <TextField
            disabled
            value={ orderAwb.pieces || '' }
            label=""
            variant="outlined"
            inputProps={{ 
              style: { padding: TEXT_FIELD_PADDINGS },
              className: classes.ipcolor 
            }}
          />
        </div>
        <div className={ `${ whsOrderAwbWeightStyles.width50 } ${ commonStyles.inputLabelWrapper }` }>
          <label className={ commonStyles.inputLabel }> Weight </label>
          <TextField
            disabled
            value={ orderAwb.weight || ''}
            label=""
            variant="outlined"
            inputProps={{ 
              style: { padding: TEXT_FIELD_PADDINGS },
              className: classes.ipcolor 
            }}
          />
        </div>
      </div>
      <div className={ whsOrderAwbWeightStyles.weightWrapper }>
        <div className={ `${ commonStyles.wrapper } ${ whsOrderAwbWeightStyles.flexWrapper }` }>
          <h3 className={ `${ commonStyles.header }` }>  Calculated Volume Weight </h3>   
          <div className={ whsOrderAwbWeightStyles.calculatedLabelInner }> 
            <p className={ whsOrderAwbWeightStyles.fs_14 } >Calculated Volume Weight :</p>
            <TextField
              disabled
              value={ props.calculatedCWT || '' }
              variant="outlined"
              className={ classes.width45 }
              inputProps={{ 
                style: { padding: TEXT_FIELD_PADDINGS },
                className: classes.ipcolor 
              }}
            />
          </div>
        </div>
        <div className={ `${ commonStyles.wrapper } ${ whsOrderAwbWeightStyles.flexWrapper }` }>
          <h3 className={ `${ commonStyles.header }` }> Scale Weight </h3>
          <div className={ classes.width55 }>
            <RadioGroup
              aria-label="measurementUnit"
              name="measurementUnit"
              value={ props.weightType || ''}
              row={ true }
              onChange={ (e) => props.calculationChange(e) }
              className={ props.classes.weightRadio }
            >
              <FormControlLabel value="auto" control={< Radio color="primary" /> } label="Use Calculated" />
              <FormControlLabel value="manual" control={ <Radio color="primary" /> } label="Enter Manually" />
            </RadioGroup>
          
            <TextField
              value={ props.orderAwb.actual_scale_weight || ''}
              disabled={ props.weightType === 'auto' }
              type="string"
              variant="outlined"
              className={ props.classes.weightInput }
              onChange={ props.handleChange('actualWeightScale') }
              inputProps={{ 
                style: { padding: TEXT_FIELD_PADDINGS },
                className: classes.ipcolor,
                min: 0,
                inputMode: 'decimal'
              }}
            />
          </div>
        </div>
      </div>

        <Fragment>
        <div className={ `${ commonStyles.wrapper } ${ whsOrderAwbWeightStyles.flexWrapper }` }>
          <h3 className={ `${ commonStyles.header }` }> Dimensions </h3> 
          <div>
            <div className={ whsOrderAwbWeightStyles.dims }>
              <div className={ whsOrderAwbWeightStyles.fs_14 }>{ props.onlyRead ? 'Dims in :' : 'Input dims in :'}</div>
              <RadioGroup
                aria-label="measurementUnit"
                name="measurementUnit"
                value={ orderAwb.cwt_data.measurement_unit }
                row={ true }
                onChange={ props.handleChange('measurementUnit') }
                className={ props.classes.radioGroup }
              >
                <FormControlLabel disabled={ orderAwb.cwt_data.data.length > 0 } value="inch" control={< Radio color="primary" /> } label="Inches" />
                <FormControlLabel disabled={ orderAwb.cwt_data.data.length > 0 } value="cm" control={ <Radio color="primary" /> } label="CMS" />
              </RadioGroup>
            </div>
            <div className={ whsOrderAwbWeightStyles.dFlex }>

              <div className={ `${ whsOrderAwbWeightStyles.width20 } ${ commonStyles.inputLabelWrapper }` }>
                <label className={ commonStyles.inputLabel }> L </label>
                <TextField
                  value={ currentDimension.length || '' }
                  type="number"
                  label="" 
                  variant="outlined"
                  onChange={ props.handleChange('length') }
                  inputProps={{ 
                    style: { padding: TEXT_FIELD_PADDINGS },
                    className: classes.ipcolor,
                    min: 0
                  }}
                  InputLabelProps={{ shrink: true }}
                />
              </div>

              <div className={ `${ whsOrderAwbWeightStyles.width20 } ${ commonStyles.inputLabelWrapper }` }>
                <label className={ commonStyles.inputLabel }> W </label>
                <TextField
                  value={ currentDimension.width || '' }
                  label=""
                  type="number"
                  variant="outlined"
                  onChange={ props.handleChange('width') }
                  inputProps={{ 
                    style: { padding: TEXT_FIELD_PADDINGS },
                    className: classes.ipcolor,
                    min: 0
                  }}
                  InputLabelProps={{ shrink: true }}
                />
              </div>

              <div className={ `${ whsOrderAwbWeightStyles.width20 } ${ commonStyles.inputLabelWrapper }` }>
                <label className={ commonStyles.inputLabel }> H </label>
                <TextField
                  value={ currentDimension.height || '' }
                  label=""
                  type="number"
                  variant="outlined"
                  onChange={ props.handleChange('height') }
                  inputProps={{ 
                    style: { padding: TEXT_FIELD_PADDINGS },
                    className: classes.ipcolor,
                    min: 0
                  }}
                  InputLabelProps={{ shrink: true }}
                />
              </div>

              <div className={ `${ whsOrderAwbWeightStyles.width20 } ${ commonStyles.inputLabelWrapper }` }>
                <label className={ commonStyles.inputLabel }> Pcs </label>
                <TextField
                  id="addPcsInput"
                  value={ currentDimension.pieces || '' }
                  label=""
                  type="number"
                  variant="outlined"
                  onChange={ props.handleChange('pieces') }
                  inputProps={{ 
                    style: { padding: TEXT_FIELD_PADDINGS },
                    className: classes.ipcolor,
                    min: 0
                  }}
                  InputLabelProps={{ shrink: true }}
                />
              </div>

              <div className={ `${ whsOrderAwbWeightStyles.width20 } ${ commonStyles.inputLabelWrapper }` }>
                <label className={ commonStyles.inputLabel }> Wgt/PC </label>
                <TextField
                  id="addWgtInput"
                  value={ currentDimension.weightPc || '' }
                  label=""
                  type="number"
                  variant="outlined"
                  onChange={ props.handleChange('weight') }
                  inputProps={{ 
                    style: { padding: TEXT_FIELD_PADDINGS },
                    className: classes.ipcolor,
                    min: 0
                  }}
                  InputLabelProps={{ shrink: true }}
                />
              </div>
            </div>
            
            <div className={whsOrderAwbWeightStyles.buttonContainer }>
              <Button
                color="primary" 
                variant="contained"
                onClick={ () => props.addRow() }
                className={classes.button} 
                style={{ marginTop:'10px', marginRight: ' 0px'}}
              >Add Dimensions
              </Button>
            </div>
            </div>

            <div className={whsOrderAwbWeightStyles.weightTableWrapper}>
              <MaterialTable 
                icons={ tableIcons }

                components={{Container: props => <Paper {...props} elevation={0} className={ commonStyles.paperTable }/>}}
                
                columns = {[
                  { title: 'L', field: 'length' },
                  { title: 'W', field: 'width' },
                  { title: 'H', field: 'height' },
                  { title: 'Pcs', field: 'pieces' },
                  { title: 'Wght/Pc', field: 'weightPc' },
                  { title: 'Total weight', field: 'totalWeight', editable: 'never' }
                ]}

                data = { orderAwb.cwt_data.data }

                editable = { {
                  onRowUpdate: (newData: any, oldData: any) =>
                    new Promise<void>((resolve, reject) => {
                      setTimeout(() => {
                        if (!isNonNegativeDimension(newData)) {
                          reject();
                          return;
                        }
                        const ordAwb: GhaPickupStatusAwb = { ...orderAwb };
                        const ordAwbList: Array<Dimension> = [...ordAwb.cwt_data.data];
                        const index: number = ordAwbList.indexOf(oldData);
                        const newItem: Dimension = {
                          length: Number(newData.length),
                          width: Number(newData.width),
                          height: Number(newData.height),
                          pieces: Number(newData.pieces),
                          weightPc: Number(newData.weightPc),
                          totalWeight: Number(newData.totalWeight)
                        };
                        let sumPieces: number = 0;
                        newItem.totalWeight = newItem.pieces * newItem.weightPc;
                        ordAwbList[index] = newItem;
                        
                        ordAwbList.forEach((item: Dimension) => {
                          sumPieces += item.pieces;
                        });

                        if (orderAwb.pieces < sumPieces) {
                          props.openExceededPiecesConfirmation();
                          reject();
                        } else {
                          ordAwb.cwt_data.data  = ordAwbList;
                          props.setOrderAwb(ordAwb); 
                          resolve();
                        }
                      }, 1000);
                  }),
                  onRowAdd: newData =>
                  new Promise<void>((resolve, reject) => {
                    setTimeout(() => {
                      if (!isNonNegativeDimension(newData)) {
                        reject();
                        return;
                      }
                      const ordAwb: GhaPickupStatusAwb = { ...orderAwb };
                      const ordAwbList: Array<Dimension> = [...ordAwb.cwt_data.data];
                      const normalized: Dimension = {
                        length: Number(newData.length),
                        width: Number(newData.width),
                        height: Number(newData.height),
                        pieces: Number(newData.pieces),
                        weightPc: Number(newData.weightPc),
                        totalWeight: Number(newData.pieces) * Number(newData.weightPc)
                      };

                      ordAwbList.push(normalized);
                      ordAwb.cwt_data.data = ordAwbList;
                      props.setOrderAwb(ordAwb); 
                      resolve();
                    }, 1000);
                  }),
                  onRowDelete: oldData =>
                    new Promise<void>((resolve, reject) => {
                      setTimeout(() => {
                        const ordAwb: GhaPickupStatusAwb = { ...orderAwb };
                        const ordAwbList: Array<Dimension> = [...ordAwb.cwt_data.data];
                        const index: number = ordAwbList.indexOf(oldData);

                        ordAwbList.splice(index, 1);
                        ordAwb.cwt_data.data = ordAwbList;
                        props.setOrderAwb(ordAwb); 
                        resolve();
                      }, 1000);
                  }) } }

                options = {{
                  sorting: false,
                  search: false,
                  paging: false,
                  showTitle: false,
                  toolbar: false,
                  actionsColumnIndex: -1,
                  headerStyle: {
                    backgroundColor: 'var(--tbl_head_bkg)',
                    color: 'var(--tbl_head_color)',
                    zIndex: 2,
                  },
                }}
              />
            </div>
      
          </div>
        </Fragment>
      
      <div className={whsOrderAwbWeightStyles.buttonContainer}>
        <Button
          color="primary" 
          variant="contained"
          onClick={ () => props.save() }
          className={ classes.button }
        >Save and Exit
        </Button>
        <Button 
          color="primary" 
          variant="contained"
          onClick={ () => props.exit() }
          className={ classes.button }
        >Exit
        </Button>
      </div>
    </div>
  );
};

export default withStyles(styles)(whsOrderAwbWeight);